<template>
  <v-flex data-qa="payee-flex-w1nqgp">
      <v-layout class="payee--gradientBGposition" data-qa="payee-layout-n9001v">
        <v-flex
          xs12
          sm12
          md12
          lg12
          xl12
          :style="{ background: dashboardGradient, height: '180px' }"
         data-qa="payee-flex-rk40t">
          <v-container class="payee--title-padding" data-qa="payee-container-etd64i">
            <v-flex xs12 sm12 md12 lg12 xl12 data-qa="payee-flex-sticm">
              <v-row no-gutters data-qa="payee-row-d05xf7a">
                <v-layout
                  row
                  wrap
                  class="pb-2"
                  :class="
                    appSettings.enableNominatedAccountFeatures &&
                    appSettings.enablePaymentsOnlyToNominatedAccounts
                      ? 'px-1 px-sm-12 px-md-12 px-lg-12 px-xl-12'
                      : 'px-12'
                  "
                 data-qa="payee-layout-2rjnv">
                  <inline-svg
                    class="mt-2"
                    :src="getNavigationIcon()"
                    width="32"
                    height="32"
                    aria-label="Navigation Icon"
                  ></inline-svg>
                  <font
                    class="headline font-weight-light pt-3 px-2 white--text"
                  >
                    <span
                      v-if="
                        appSettings.enableNominatedAccountFeatures &&
                        appSettings.enablePaymentsOnlyToNominatedAccounts
                      "
                     data-qa="payee-span-sot6ia">
                      {{ $t("payee.ownAccountTitle") }}
                    </span>
                    <span v-else data-qa="payee-span-fl16kn"> {{ $t("payee.title") }} </span>
                  </font>
                </v-layout>
              </v-row>
            </v-flex>
          </v-container>
        </v-flex>
      </v-layout>
      <!-- P A Y E E   C A R D -->
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        class="payee--content-padding payee--overlayCardFlex"
       data-qa="payee-flex-y3crgs">
        <v-layout
          row
          wrap
          class="payee--content-padding addNewPayee--textfield-bgColor"
         data-qa="payee-layout-vc7yx">
          <v-col v-if="isAddDeletePayeePermitted.sameBank || isAddDeletePayeePermitted.ukfps || isAddDeletePayeePermitted.sepa" cols="12" class="pt-0 hidden-md-and-up" data-qa="payee-col-xc11w">
            <add-new-payee-btn
              :text="addNewPayeeButtonText"
              @click="gotoAddNewPayee"
            />
          </v-col>
          <v-flex xs11 sm8 md8 lg9 xl9  data-qa="payee-flex-aiq2jn">
            <v-card data-qa="payee-card-4i96m">
              <v-tabs v-if="showTabs" class="pa-6" :color="primaryColor" v-model="currentTab" data-qa="payee-tabs-03ijjo">
                <v-tabs-slider
                  :color="primaryColor"
                 data-qa="payee-tabs-slider-0n1iqp"></v-tabs-slider>
                <v-tab
                  v-for="(item, i) in totalTabs"
                    :key="item"
                    :class="'font-weight-bold'"
                    style="text-transform: none;"
                    :data-tab="item"
                    :data-qa="`payee-tab-4v0j8-${i}`"
                  >
                    {{ item }}
                </v-tab>
              </v-tabs>
              <v-tabs-items :color="primaryColor" v-model="currentTab" data-qa="payee-tabs-items-g31q95">
                <v-tab-item
                  :color="primaryColor"
                 data-qa="payee-tab-item-sehgdm">
                  <v-flex class="pt-2 px-4" data-qa="payee-flex-5v56u">
                    <v-text-field
                      v-model="sameBankSearch"
                      prepend-inner-icon="mdi-magnify"
                      :label="$t('payee.searchPayee')"
                      filled
                      class="mx-2 mb-n4 mt-n2"
                      :color="primaryColor"
                     data-qa="payee-text-field-afjrj4"></v-text-field>
                    <v-list
                      v-if="filteredSameBankAccs && filteredSameBankAccs.length"
                      class="mx-2"
                      subheader
                      two-line
                     data-qa="payee-list-4sc0o">
                      <template
                        v-for="(account, index) in filteredSameBankAccs"
                      >
                        <v-list-item :key="account.accountNumber" :data-qa="`payee-list-item-c13xvu-${index}`">
                          <v-row :data-qa="`payee-row-39jb0q-${index}`">
                            <v-flex xs12 sm12 md12 lg7 xl8 :data-qa="`payee-flex-pi9boa-${index}`">
                              <v-list-item-content
                                class="
                                  px-4
                                  px-sm-auto
                                  px-md-auto
                                  px-lg-auto
                                  px-xl-auto
                                "
                                :data-qa="`payee-list-item-content-6weszq-${index}`">
                                <v-list-item-title
                                  class="text--primary"
                                  v-text="account.name"
                                  :data-qa="`payee-list-item-title-3bp8lt-${index}`"></v-list-item-title>

                                <v-list-item-subtitle
                                  v-text="account.accountNumber"
                                  :data-qa="`payee-list-item-subtitle-h32otq-${index}`"></v-list-item-subtitle>
                              </v-list-item-content>
                            </v-flex>
                            <v-flex
                              xs12
                              sm12
                              md12
                              lg5
                              xl4
                              class="
                                mt-xs-auto mt-sm-auto mt-md-auto mt-lg-4 mt-xl-4
                                pl-4
                              "
                              :data-qa="`payee-flex-2k4noa-${index}`">
                              <v-list-item-action :data-qa="`payee-list-item-action-4zundp-${index}`">
                                <v-row :data-qa="`payee-row-k5qftk-${index}`">
                                  <v-btn
                                    v-if="isTransferFundsPermitted(account, currentTab)"
                                    text
                                    :color="primaryColor"
                                    class="
                                      text-none
                                      px-3
                                      mt-4
                                      mt-sm-auto
                                      mt-md-auto
                                      mt-lg-auto
                                      mt-xl-auto
                                    "
                                    @click="transferFunds(account, currentTab)"
                                    :data-qa="`payee-btn-xy5frn-${index}`">
                                    <v-icon left class="material-symbols-outlined" :data-qa="`payee-icon-p24j6i-${index}`"> sync </v-icon>
                                    {{ $t("payee.transferFunds") }}</v-btn
                                  >
                                  <v-btn
                                    v-if="isAddDeletePayeePermitted.sameBank"
                                    text
                                    :color="primaryColor"
                                    class="text-none px-2"
                                    @click="onDeletePayee(account)"
                                    :data-qa="`payee-btn-3doo-${index}`">
                                    <v-icon left class="material-symbols-outlined" :data-qa="`payee-icon-c4bpad-${index}`">  delete </v-icon>
                                    {{ $t("payee.deleteBtn") }}
                                  </v-btn>
                                </v-row>
                              </v-list-item-action>
                            </v-flex>
                          </v-row>
                        </v-list-item>
                        <v-divider
                          v-if="filteredSameBankAccs && index < filteredSameBankAccs.length - 1"
                          :key="index"
                          class="my-2 my-lg-auto my-xl-auto"
                          :data-qa="`payee-divider-oh9uqd-${index}`"></v-divider>
                      </template>
                    </v-list>
                    <v-row v-else no-gutters justify="center" class="pa-6" data-qa="payee-row-pqbxf">
                      {{ $t('payee.notAvailable')}}
                    </v-row>
                  </v-flex>
                </v-tab-item>
                <v-tab-item data-qa="payee-tab-item-5nsww">
                  <v-flex :class="appSettings.enableSameBankPayee ? 'pt-2 px-4' : 'pt-8 px-4'" data-qa="payee-flex-ussc27">
                    <v-text-field
                      v-model="otherBankSearch"
                      prepend-inner-icon="mdi-magnify"
                      :label="$t('payee.searchPayee')"
                      filled
                      class="mx-2 mb-n4 mt-n2"
                      :color="primaryColor"
                     data-qa="payee-text-field-m2488k"></v-text-field>
                    <v-flex
                      v-if="
                        !(
                          appSettings.enableNominatedAccountFeatures &&
                          appSettings.enablePaymentsOnlyToNominatedAccounts
                        )
                      "
                      class="mx-5 pb-4"
                      data-qa="payee-flex-hpw9x9"
                    >
                      <v-tabs
                        :color="primaryColor"
                        v-model="showLinkedAccounts"
                        class="text-capitalize"
                        data-qa="payee-tabs-czjo5s"
                      >
                        <v-tab
                          id="myAcc"
                          class="text-none font-weight-bold"
                        >
                          {{ $t("payee.linkedAccBtn") }}
                        </v-tab>
                        <v-tab
                          id="payAcc"
                          class="text-none font-weight-bold"
                        >
                          {{ $t("payee.payeeBtn") }}
                        </v-tab>
                        <v-tab
                          v-if="enableSwiftPayee && !isSmeLogin"
                          id="payAcc"
                          class="text-none font-weight-bold"
                        >
                          {{ $t("payee.swiftPayee") }}
                        </v-tab>
                      </v-tabs>
                    </v-flex>

                    <!-- My Accounts / Payee accounts list -->
                    <v-list
                      v-if="[0, 1].includes(showLinkedAccounts) && filteredOtherBankAccs.length"
                      class="mx-2"
                      subheader
                      two-line
                      data-qa="payee-list-e839a"
                    >
                      <template
                        v-for="(account, index) in filteredOtherBankAccs"
                      >
                        <v-list-item :key="account.beneficiaryId" :data-qa="`payee-list-item-pwde36-${index}`">
                          <v-row :data-qa="`payee-row-d47xy-${index}`">
                            <v-flex xs12 sm12 md12 lg6 xl8 :data-qa="`payee-flex-4d7du8-${index}`">
                              <v-list-item-content
                                class="
                                  px-4
                                  px-sm-auto
                                  px-md-auto
                                  px-lg-auto
                                  px-xl-auto
                                "
                                :data-qa="`payee-list-item-content-vgl7lr-${index}`">
                                <v-list-item-title
                                  class="text--primary"
                                  v-text="account.name"
                                  :data-qa="`payee-list-item-title-0a54cd-${index}`"></v-list-item-title>
                                <v-list-item-subtitle
                                  v-text="
                                    `${account.accountIdentification} | ${account.bankIdentifier}`
                                  "
                                  :data-qa="`payee-list-item-subtitle-6moubo-${index}`"></v-list-item-subtitle>
                              </v-list-item-content>
                            </v-flex>
                            <v-flex
                              xs12
                              sm12
                              md12
                              lg6
                              xl4
                              class="
                                mt-xs-auto mt-sm-auto mt-md-auto mt-lg-4 mt-xl-4
                                pl-4
                              "
                              :data-qa="`payee-flex-fmhc7-${index}`">
                              <v-list-item-action :data-qa="`payee-list-item-action-e6a17m-${index}`">
                                <v-row :data-qa="`payee-row-j3bukrw-${index}`">
                                  <v-btn
                                    v-if="isTransferFundsPermitted(account, currentTab)"
                                    text
                                    :color="primaryColor"
                                    class="text-capitalize"
                                    @click="transferFunds(account, currentTab)"
                                    :data-qa="`payee-btn-6tug5g-${index}`">
                                    <v-icon class="material-symbols-outlined" :data-qa="`payee-icon-x2nasf-${index}`"> sync </v-icon>
                                    {{ $t("payee.transferFunds") }}
                                  </v-btn>
                                  <v-btn
                                    text
                                    :color="primaryColor"
                                    @click="viewDetails(account)"
                                    class="text-capitalize"
                                    :data-qa="`payee-btn-rfw2q8u-${index}`">{{ $t("payee.viewDetails") }}</v-btn
                                  >
                                </v-row>
                              </v-list-item-action>
                            </v-flex>
                          </v-row>
                        </v-list-item>
                        <v-divider
                          v-if="index < filteredOtherBankAccs.length - 1"
                          :key="index"
                          class="my-2 my-lg-auto my-xl-auto"
                          :data-qa="`payee-divider-0cgxu-${index}`"></v-divider>
                      </template>
                    </v-list>

                    <!-- SWIFT payee list -->
                    <v-list
                      v-if="showLinkedAccounts === 2 && swiftBeneficiaryList?.items?.length"
                      class="mx-2"
                      subheader
                      two-line
                      data-qa="payee-list-e839a"
                    >
                      <template
                        v-for="(account, index) in swiftBeneficiaryList?.items"
                      >
                        <v-list-item :key="account.beneficiaryId" :data-qa="`payee-list-item-pwde36-${index}`">
                          <v-row :data-qa="`payee-row-d47xy-${index}`">
                            <v-flex xs12 sm12 md12 lg6 xl8 :data-qa="`payee-flex-4d7du8-${index}`">
                              <v-list-item-content
                                class="
                                  px-4
                                  px-sm-auto
                                  px-md-auto
                                  px-lg-auto
                                  px-xl-auto
                                "
                                >
                                <v-list-item-title
                                  class="text--primary"
                                  v-text="account.name"
                                  :data-qa="`payee-list-item-title-0a54cd-${index}`"
                                />
                                <v-list-item-subtitle
                                  v-text="
                                    `${account.beneficiaryAccountNumber} | ${account.beneficiaryBankBic}`
                                  "
                                  :data-qa="`payee-list-item-subtitle-6moubo-${index}`"
                                />
                              </v-list-item-content>
                            </v-flex>
                            <v-flex
                              xs12
                              sm12
                              md12
                              lg6
                              xl4
                              class="
                                mt-xs-auto mt-sm-auto mt-md-auto mt-lg-4 mt-xl-4
                                pl-4
                              "
                              :data-qa="`payee-flex-fmhc7-${index}`">
                              <v-list-item-action :data-qa="`payee-list-item-action-e6a17m-${index}`">
                                <v-row :data-qa="`payee-row-j3bukrw-${index}`">
                                  <v-btn
                                    v-if="isTransferFundsPermitted(account, currentTab)"
                                    text
                                    :color="primaryColor"
                                    class="text-capitalize"
                                    @click="transferFunds(account, currentTab)"
                                    :data-qa="`payee-btn-6tug5g-${index}`">
                                    <v-icon class="material-symbols-outlined" :data-qa="`payee-icon-x2nasf-${index}`"> sync </v-icon>
                                    {{ $t("payee.transferFunds") }}
                                  </v-btn>
                                  <v-btn
                                    text
                                    :color="primaryColor"
                                    @click="viewDetails(account)"
                                    class="text-capitalize"
                                    :data-qa="`payee-btn-rfw2q8u-${index}`">{{ $t("payee.viewDetails") }}</v-btn
                                  >
                                </v-row>
                              </v-list-item-action>
                            </v-flex>
                          </v-row>
                        </v-list-item>
                        <v-divider
                          v-if="index < swiftBeneficiaryList?.items?.length - 1"
                          :key="index"
                          class="my-2 my-lg-auto my-xl-auto"
                          :data-qa="`payee-divider-0cgxu-${index}`"></v-divider>
                      </template>
                    </v-list>

                    <!-- No records available -->
                    <v-row
                      v-if="noAvailableData"
                      no-gutters
                      justify="center"
                      class="pa-6"
                    >
                      {{ $t('payee.notAvailable') }}
                    </v-row>

                  </v-flex>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-flex>
          <v-flex xs1 sm4 md4 lg3 xl3
            v-if="isAddDeletePayeePermitted.sameBank || isAddDeletePayeePermitted.ukfps || isAddDeletePayeePermitted.sepa"
            class="mt-4 flex-start hidden-sm-and-down"
            :class="
              appSettings.enableNominatedAccountFeatures &&
              appSettings.enablePaymentsOnlyToNominatedAccounts
                ? 'px-2'
                : 'px-8'
            "
           data-qa="payee-flex-i5yeu8">
            <add-new-payee-btn
              :text="addNewPayeeButtonText"
              @click="gotoAddNewPayee"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    <!-- Confirmation modal - Delete Payee -->
    <Modal
      v-if="showDeleteConfirmationModal"
      :config='modalConfig.confirmDeletePayee'
      @btn1Action="onDeletePayeeConfirm"
      @btn2Action="onCancel">
    </Modal>
    <!-- Successful modal to Delete Payee -->
    <Modal
      v-if="isDeletePayeeSuccessful"
      :config='getDeletePayeeSuccessConfig'
      @btn1Action="isDeletePayeeSuccessful = false;
              accountToDelete = {};">
    </Modal>
    <!-- OTP Section for Delete Payee -->
    <Modal
      v-if="showOTPScreen"
      :config="otpModalConfig"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="payee-span-p39q68">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
  </v-flex>
</template>

<script>
import '@/styles/pages/payee.scss'
import commonService from '@/service/commonService.js'
import store from '@/core/store'
import event from '@/util/event'
import WrappedButton from '@/views/common/buttons/WrappedButton.vue'
import getFormConfig from '@/util/formUtility.js'

export default {
  components: {
    Modal: () => import('@/components/common/Modal.vue'),
    OtpInput: () => import('@/components/common/OtpInput.vue'),
    'add-new-payee-btn': WrappedButton
  },
  data () {
    return {
      currentTab: null,
      sameBankSearch: '',
      otherBankSearch: '',
      totalTabs: [
        this.$t('payee.sameBank'),
        this.$t('payee.otherBank')
      ],
      showTabs: true,
      sameBankAccounts: [],
      otherBankAccounts: [],
      showDeleteConfirmationModal: false,
      accountToDelete: {},
      showLinkedAccounts: 0,
      showOTPScreen: false,
      isDeletePayeeSuccessful: false,
      appSettings: this.$appSettings.defaultConfigurations.nominatedAccounts,
      enableOTPToDeletePayee:
        this.$appSettings.defaultConfigurations.enableOTPManagePayee.deletePayee,
      otpModalConfig: {
        enabled: false,
        persistent: true,
        enableSave: true,
        close: true,
        saveButton: '',
        outlinedSaveBtn: false,
        title: this.$t('otp.toolBarTitle'),
        width: 400
      },
      modalConfig: {
        confirmDeletePayee: {
          enabled: true,
          title: this.$t('addNewPayee.deleteCheck'),
          body: this.$t('recurringAndFuturePayments.confirmSubtitle'),
          persistent: true,
          btn1Label: this.$t('recurringAndFuturePayments.delete'),
          btn2Label: this.$t('recurringAndFuturePayments.cancel'),
          width: 400
        },
        deletePayeeSuccess: {
          enabled: true,
          persistent: true,
          body: this.$t('recurringAndFuturePayments.subtitle'),
          btn1Label: this.$t('common.okay'),
          width: 600
        }
      },
      otpSettings: {
        resetPasswordTime:
          this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      schema: {
        beneficiaryDetails: { exists: true }
      },
      enableUDFBeneficiaryForAddPayee: this.$appSettings.defaultConfigurations.enableUDFBeneficiaryForAddPayee,
      isAddDeletePayeePermitted: {
        sameBank: false,
        ukfps: false,
        sepa: false
      },
      permissions: [],
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
      swiftBeneficiaryList: [],
      enableSwiftPayee: this.$appSettings.defaultConfigurations.nominatedAccounts.enableSwiftPayee
    }
  },
  computed: {
    filteredSameBankAccs () {
      if (this.sameBankAccounts && this.sameBankAccounts.length) {
        return this.sameBankAccounts.filter((item) => {
          const textOne = item.name?.toLowerCase()
          const textTwo = item.accountNumber?.toLowerCase()
          const searchText = this.sameBankSearch?.toLowerCase()
          return (
            textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
          )
        })
      }
      return this.sameBankAccounts
    },
    filteredOtherBankAccs () {
      let temp = []
      if (this.otherBankAccounts && this.otherBankAccounts.length) {
        temp = this.showLinkedAccounts === 2 ? [] : this.otherBankAccounts.filter((item) => {
          return this.showLinkedAccounts === 0
            ? item.ownAccount === true
            : item.ownAccount === false
        })
        return temp.filter((item) => {
          const textOne = item.name?.toLowerCase()
          const textTwo = item.accountIdentification?.toLowerCase()
          const textThree = item.bankIdentifier?.toLowerCase()
          const searchText = this.otherBankSearch?.toLowerCase()
          return (
            textOne.indexOf(searchText) > -1 ||
            textTwo.indexOf(searchText) > -1 ||
            textThree.indexOf(searchText) > -1
          )
        })
      }
      return temp
    },
    addNewPayeeButtonText () {
      return this.appSettings.enableNominatedAccountFeatures && this.appSettings.enablePaymentsOnlyToNominatedAccounts
        ? this.$t('payee.nominatedAddNewPayeeBtn')
        : this.$t('payee.addNewPayeeBtn')
    },
    getDeletePayeeSuccessConfig () {
      return {
        ...this.modalConfig.deletePayeeSuccess,
        title: this.$t('payee.successDeleteMsg', { name: this.accountToDelete.name })
      }
    },
    noAvailableData () {
      const isSepaOrUkfps = [0, 1].includes(this.showLinkedAccounts)
      const isSwift = this.showLinkedAccounts === 2

      return (isSepaOrUkfps && this.filteredOtherBankAccs?.length === 0) ||
        (isSwift && this.swiftBeneficiaryList?.items?.length === 0)
    }
  },
  async created () {
    this.permissions = store.getters['profileStore/profileData']?.permissions

    this.isAddDeletePayeePermitted.sameBank = (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes('ADD_AND_DELETE_SAME_BANK_PAYEES') : true
    this.isAddDeletePayeePermitted.ukfps = (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes('ADD_AND_DELETE_UKFPS_PAYEES') : true
    this.isAddDeletePayeePermitted.sepa = (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes('ADD_AND_DELETE_SEPA_PAYEES') : true

    this.modalConfig.confirmDeletePayee.btn1Color = this.errorColor
    this.modalConfig.confirmDeletePayee.btn2Color = this.errorColor

    if (this.appSettings.enableSameBankPayee) {
      this.currentTab = 0
      this.showTabs = true
    } else {
      this.currentTab = 1
      this.showTabs = false
    }

    // if the page is being loaded after delete payee then it will have the returnToTab key in params - use it to set the tab to show
    if (this.$route.params && this.$route.params.returnToTab) {
      this.currentTab = this.$route.params.returnToTab
    }
    await this.storeUDFGenericCodeList()
    if (this.$route.params && this.$route.params.accountType) {
      this.currentTab = 1
      const cachedOtherBankAccounts =
        store.getters['profileStore/profileData'].otherBankAccounts
      const cachedSameBankAccounts =
        store.getters['profileStore/profileData'].sameBankAccounts
      this.otherBankAccounts =
        cachedOtherBankAccounts || await this.getOtherBankAccounts()
      this.sameBankAccounts =
        cachedSameBankAccounts || await this.getSameBankAccounts()
    } else {
      await this.getSameBankAccounts()
      await this.getOtherBankAccounts()
    }
    this.getSwiftBeneficiaries()
    event.$on('IS_OTP_VALID', async (valid) => {
      if (valid && this.showOTPScreen) {
        this.showOTPScreen = false
        this.otpModalConfig.enabled = false
        await this.deleteIntraPayee()
      } else {
        this.otpModalConfig.enableSave = true
      }
    })
    event.$on('OTP_RESENT', (val) => {
      this.otpModalConfig.enableSave = true
    })
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('Payees')
    },
    async getSameBankAccounts () {
      const resp = await commonService.retrieveInternalBeneficiary(
        JSON.parse(sessionStorage.getItem('username'))
      )
      if (resp && resp.beneficiaryList) {
        this.sameBankAccounts = resp.beneficiaryList.map((item) => {
          return {
            name: item.beneficiaryReference,
            accountNumber: item.beneficiaryAccount,
            beneficiaryId: item.beneficiaryId
          }
        })
        store.dispatch('profileStore/setProfileData', {
          sameBankAccounts: this.sameBankAccounts
        })
      } else {
        this.sameBankAccounts = []
      }
    },
    async getOtherBankAccounts () {
      const resp = await commonService.getCustomBeneficiaries(
        JSON.parse(sessionStorage.getItem('username'))
      )
      if (resp && resp.items) {
        this.otherBankAccounts = resp.items
        store.dispatch('profileStore/setProfileData', {
          otherBankAccounts: resp.items
        })
      } else {
        this.otherBankAccounts = []
      }
    },
    viewDetails (account) {
      store.dispatch('profileStore/setProfileData', {
        selectedPayeeDetails: account
      })
      this.$router.push({ name: 'PayeeDetails', params: { comingFromTab: this.currentTab } })
    },
    transferFunds (account, tab) {
      if (account) {
        if (tab === 1) {
          this.$router.push({
            name: account.paymentSystem === 'SWIFT'
              ? 'Swift Payments'
              : account.paymentSystem === 'STEP2'
                ? 'InternationalPayments'
                : 'DomesticPayments',
            params: {
              payeeAccountNumber: account.accountIdentification,
              payeeName: account.name,
              payeeSortCode: account.bankIdentifier,
              payeeAccount: account
            }
          })
        } else {
          this.$router.push({
            name: 'transferFunds',
            params: {
              beneficiaryAccount: account.accountIdentification
                ? account.accountIdentification
                : account.accountNumber,
              beneficiaryReference: account.name
            }
          })
        }
      }
    },
    onDeletePayee (account) {
      this.accountToDelete = account
      this.showDeleteConfirmationModal = true
      this.modalConfig.confirmDeletePayee.enabled = true
    },
    async onDeletePayeeConfirm () {
      this.showDeleteConfirmationModal = false
      this.modalConfig.confirmDeletePayee.enabled = false
      if (this.enableOTPToDeletePayee) {
        this.showOTPScreen = true
        this.otpModalConfig.enabled = true
      } else {
        await this.deleteIntraPayee()
      }
    },
    async deleteIntraPayee () {
      if (this.accountToDelete) {
        const response = await commonService.deleteIntraBankBeneficiary(
          this.accountToDelete.beneficiaryId
        )
        if (!response.causes && response.status === 'SUCCESS') {
          this.isDeletePayeeSuccessful = true
        }
        this.getSameBankAccounts()
        this.showDeleteConfirmationModal = false
        this.otpModalConfig.enabled = false
      }
    },
    onOtpModalClose () {
      this.otpModalConfig.enabled = false
      this.showOTPScreen = false
    },
    gotoAddNewPayee () {
      this.$router.push({
        name: 'Add New Payee',
        params: {
          comingFromTab: this.currentTab
        }
      })
    },
    async storeUDFGenericCodeList () {
      if (!this.enableUDFBeneficiaryForAddPayee) { return }

      const form = await commonService.getFormData(`UDF_AddBeneficiary-${this.$i18n.locale}`)
      this.schema.beneficiaryDetails = getFormConfig(form)

      if (!this.schema.beneficiaryDetails.schema) { return }

      const code = { codeReferences: [] }
      for (const i in this.schema.beneficiaryDetails.schema) {
        if (this.schema.beneficiaryDetails.schema[i].gcReferenceKey) {
          code.codeReferences.push({ reference: this.schema.beneficiaryDetails.schema[i].gcReferenceKey })
        }
      }
      const response = await commonService.getGenericCodes(code)
      sessionStorage.setItem('udfGenericCodes', JSON.stringify(response.aggregateCodes))
    },
    onCancel () {
      this.showDeleteConfirmationModal = false
      this.modalConfig.confirmDeletePayee.enabled = false
    },
    isTransferFundsPermitted (account, tab) {
      if (!this.isSmeLogin || !this.enableRoleBasedAccess) {
        return true
      }

      if (tab === 1) {
        return account.paymentSystem === 'STEP2'
          ? this.permissions?.includes('SEPA')
          : this.permissions?.includes('UKFPS')
      }

      return this.permissions?.includes('TRANSFER_FUNDS')
    },
    async getSwiftBeneficiaries () {
      this.swiftBeneficiaryList = await commonService.getSwiftBeneficiaries(JSON.parse(sessionStorage.getItem('username')))
      this.swiftBeneficiaryList.items.forEach(item => {
        item.paymentSystem = 'SWIFT'
      })
    }
  },
  watch: {
    showOTPScreen () {
      if (this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    }
  }
}
</script>
